<template>
    <div>
        <div class="search_head">
            <a-form layout="inline" style="padding: 0">
                <a-form-item label="">
                    <a-input v-model="kw" style="width:250px"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" html-type="submit" @click="loadtable()">
                        搜索
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="search_content">
            <a-table :columns="columns" :data-source="table" bordered size="small" :loading="loading"
                :rowKey="(record, index) => { return index }">
            </a-table>
        </div>
    </div>
</template>
<script>
import { get, post } from "../../assets/js/request";
import Audio from './Audio.vue';
export default {
    components: { Audio },
    data() {
        return {
            table: [],
            kw: '',
            columns: [
                {
                    title: '序号',
                    customRender: (text, record, index) => `${index + 1}`,
                    width: 50,
                },
                {
                    title: "id",
                    dataIndex: "file_id",
                }, {
                    title: "名称",
                    dataIndex: "file_name",
                },
                , {
                    title: "链接",
                    dataIndex: "url",
                }, {
                    title: "时长",
                    dataIndex: "duration",
                }
                , {
                    title: "状态",
                    dataIndex: "state",
                }, {
                    title: "用户id",
                    dataIndex: "uid",
                }
            ],
            loading: false,
        };
    },
    created() {
        this.loadtable();
    },
    methods: {
        loadtable() {
            this.loading = true;
            get("/music/list", {
                name: this.kw,
            }).then((res) => {
                this.loading = false;
                this.table = res.data;
            });
        }, link_products(products) {
            var p = [];
            for (product in products) {
                p.push(product.product_name);
            }
            return p.join();
        }

    },
};
</script>